import { Injectable } from '@angular/core';
import { InternationalPaymentSuccessComponent } from '../../../components/payments/international-payment-success/international-payment-success.component';
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {
  InternationalPaymentSuccessModel
} from "../../../components/payments/international-payment-success/international-payment-success.model";

@Injectable({
  providedIn: 'root'
})
export class InternationalPaymentSuccessService {

  private modalRef!: NgbModalRef;

  constructor(private modalService: NgbModal, private modalConfig: NgbModalConfig) {
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;
  }


  open(paymentSuccess: InternationalPaymentSuccessModel) {
    this.modalRef = this.modalService.open(InternationalPaymentSuccessComponent);
    this.modalRef.componentInstance.paymentSuccessModel = paymentSuccess;
    this.modalRef.componentInstance.modalRef = this.modalRef;
  }

}
